// extracted by mini-css-extract-plugin
export default {"root":"Error_root__lc7vb"};